/**
 * The "who we are" panel shown alongside the login/signup forms - ported
 * verbatim (same copy) from the retired Jinja auth pages
 * (components/user/user_login.html / user_register.html), which showed
 * this text in a second column next to the form. Kept as a shared
 * component so both pages stay in sync rather than duplicating the copy.
 */
export function AuthInfoPanel() {
  return (
    <div className="rounded-lg border border-border bg-bg-secondary p-6">
      <h2 className="mb-3 text-xl font-light text-text-primary">Vision Portal</h2>
      <p className="mb-3 text-sm font-light text-text-secondary">
        Ariya Finergy, Your Power Partner, is an industry leader in supplying and financing clean energy, storage and
        power quality systems. We provide seamless end-to-end service supported by our dedicated services team.
      </p>
      <p className="mb-3 text-sm font-light text-text-secondary">
        Our highly experienced team and full vertical integration sets Ariya apart and allows us to deliver
        innovative power solutions customized to your unique operating requirements.
      </p>
      <p className="text-sm font-light text-text-secondary">
        We are Your Power Partner along every step of your solar journey – let&rsquo;s start working together today!
      </p>
    </div>
  )
}
